import * as React from 'react';

export interface NavHelperProps {
  pageName: string;
  icon: string;
}

export default class NavHelper extends React.PureComponent<NavHelperProps> {
  render(): JSX.Element {
    return (
      <section id="nav-helper" className="nav-helper bg-image" style={{ background: 'url("assets/images/all/masshead-1.jpg") no-repeat 50% 50%' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-5">
              <div className="page-head">
                <i className={'fa ' + this.props.icon} />
                <h2>{this.props.pageName}</h2>
              </div>
            </div>
            <div className="col-md-7">
              <ol className="breadcrumb ">
                <li><a href="/">Home</a></li>
                <li className="active"><span>{this.props.pageName}</span></li>
              </ol>
            </div>
          </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NavHelper.tsx